module.exports = __webpack_public_path__ + "static/media/account.5ac4a16a.svg";